<template>
	<div>
		<!-- header -->
		<Header :isHome="false"></Header>


		<!-- s1 -->
		<div class="container s1-box" style=";padding-bottom: 3rem;">
			<div class="row s1-row" style="align-items: flex-start;padding: 0rem;">
				<div class="col-6">
					<div class="title-box">
						<img src="../../assets/imgs/export-title-icon.png" class="title-icon">
						<span class="title-text">About GCI</span>
					</div>

					<div style="color: #333;margin-top: 2rem;font-size: 1rem;user-select: none;">
						<!-- 2024.8.7新增 -->
						Globalcare-Info is a pioneer in the field of global business information services, building
						close connections across various global industry chains through its powerful digital platform.
						We embrace a vision that spans different fields and borders, utilizing technology to create
						broader opportunities for enterprises. We focus on providing comprehensive services and
						intelligent solutions, offering limitless opportunities for business collaboration and
						investment. Globalcare-Info is committed to driving innovation and transformation in various
						industries, leading the way for future development, disrupting traditions, and creating a
						brand-new future.
						<!-- Globalcare-Info merges the forefront of international business consultancy with a dynamic digital platform, crafting vital connections across global industry chains. Our encompassing vision transcends sectors and borders, employing technology to broaden prospects for enterprises. By delivering extensive services and intelligent solutions, we are a conduit for collaborative and investment opportunities, poised to disrupt and transform industries. Globalcare-Info is resolutely paving the path for innovative development, charting a course for a transformative future. -->


						<!-- <div style="margin-bottom: 1rem;">Globalcare-Info (GCI) is a centralized one-stop platform specialized for the global Tissue & Hygiene industry, providing constantly updated information and professional insights into the present market and beyond.</div>
							
							<div style="margin-bottom: 1rem;">Drawing from a pool of experts, industry associations, partner enterprises, and data production teams, GCI consolidates high-quality resources to provide practical solutions to address complex challenges occurring during business operations, assisting businesses in process optimization, maximizing productivity and efficiency, and empowering high-quality development</div>
							
							<div>In summary, GCI is a valuable resource and solution provider for those operating in the Tissue & Hygiene industry</div> -->
					</div>
				</div>
				<div class="col-6 s1-r" style="position: relative;height: 26.6rem;">
					<!-- s1右侧底色 -->
					<div style="position: absolute;right: 0rem;bottom: 0rem;background-color: #23f7d3;height: 26.6rem;width: 28rem;"
						class="s1-img-bg"></div>
					<!-- s1右侧轮播图片 -->
					<div
						style="position: absolute;right: 1rem;bottom: 1rem;height: 26.6rem;width: 30rem;overflow: hidden;display: flex;">
						<div :style="{ marginLeft: '-' + active * 30 + 'rem' }" class="transition-normal"
							style="display: flex;">
							<div style="height: 26.6rem;min-width: 30rem;" class="s1-img"
								v-for="(topimg, topimgindex) in topimglist" :key="topimgindex"
								:style="{ backgroundImage: 'url(' + topimg.image + ')' }"></div>
						</div>
					</div>
					<!-- s1右侧下方点 -->
					<div
						style="position: absolute;bottom: 2rem;left:3rem;right: 0;display: flex;align-items: center;justify-content: center;">
						<div style="width: 0.5rem;height: 0.5rem;border-radius: 50%;margin: 0 0.3rem;cursor: pointer;"
							v-for="i in topimglist.length" :key="i"
							:style="{ backgroundColor: i - 1 == active ? '#31ffda' : '#a4a4a4' }"
							@click="clickcircle(i)"></div>
					</div>
				</div>
			</div>
		</div>

		<!-- s2 -->
		<!-- <div class="" style="background: linear-gradient(167deg, rgba(220,255,252,0.58) 0%, #FFFFFF 100%);padding-top: 3rem;">
			<div class="container">
				<div class="title-box" style="align-items: center;justify-content: center;">
					<img src="../../assets/imgs/export-title-icon.png" class="title-icon" style="margin-top: 0.3rem;">
					<span class="title-text">Team Members</span>
				</div>
				<div style="color: #333;font-size: 1rem;margin-top: 2rem;">
					Nicolas Julia is the co-founder and CEO of Sorare, the global sports entertainment company that puts team ownership in the hands of fans. A serial entrepreneur and avid sports fan, Nicolas was inspired to launch Sorare from his own childhood experience of collecting football stickers, combined with his discovery of an innovation enabling digital ownership: non-fungible technology (NFT). Believing that sports fandom could be t
				</div>
				
				<div class="row">
					<div class="col-3" v-for="(item, index) in piclist" :key="index" style="margin-top: 4rem;">
						<div style="width: 100%;height: 20rem;background-size: cover;background-position: center;background-repeat: no-repeat;"
								:style="{backgroundImage: 'url('+item.img+')'}" class="s2-img"></div>
						<div style="margin-top: 1rem;font-size: 1.2rem;font-weight: bold;display: flex;align-items: center;justify-content: center;">
							{{item.name}}
						</div>
					</div>
				</div>
			</div>
		</div>	 -->

		<!-- s3 -->
		<div class="" style=";padding-top: 3rem;">
			<div class="container">
				<div class="title-box" style="align-items: center;justify-content: center;">
					<img src="../../assets/imgs/export-title-icon.png" class="title-icon" style="margin-top: 0.3rem;">
					<span class="title-text">PARTNERS</span>
				</div>
				<div
					style="color: #333;font-size: 1.2rem;margin-top: 2rem;display: flex;align-items: center;justify-content: center;">
					<span style="max-width: 40rem;text-align: center;"></span>GCI welcomes global partners to join us
					for a better future
				</div>

				<div class="row">
					<div class="col-2" v-for="(item, tagindex) in 24" :key="tagindex" style="margin-top: 4rem;">
						<div style="width: 100%;height: 6rem;background-size: contain;background-position: center;background-repeat: no-repeat;"
							:style="{ backgroundImage: 'url(' + require('../../assets/imgs/about/' + tagindex + '.png') + ')' }">
						</div>
					</div>
				</div>
			</div>
		</div>


		<!-- 问题模块 -->
		<div style="padding-top: 3rem;">
			<div class="container">
				<div class="row" style="margin-bottom: 3rem;margin: 0 0.2rem;">
					<div
						style="display: flex;align-items: center;justify-content: center;width: 100%;font-size: 2rem;font-weight: bold;margin-bottom: 2rem;">
						<img src="../../assets/imgs/export-title-icon.png" style="width: 3rem;height: 3rem;">
						<span style="margin-left: -2rem;">FAQS</span>
					</div>
					<Question type="2"></Question>
				</div>
			</div>
		</div>

		<!-- s4 -->
		<div style="padding-top: 5rem;">
			<div class="container">
				<div class="row" style="margin-bottom: 3rem;">
					<div class="col-5">
						<div style="display: flex;flex-direction: column;">
							<div class="s4-title">Company Location:</div>
							<div class="s4-text">{{ data.address }}</div>
							<div class="s4-title">Email Address:</div>
							<div class="s4-text">{{ data.email }}</div>
							<div class="s4-title">Phone Number:</div>
							<div class="s4-text">{{ data.phone }}</div>
							<div class="s4-title">Connect with us:</div>
							<div style="display: flex;" v-if="data">
								<!-- facebook -->
								<img src="../../assets/imgs/footer-icon-1.png" class="s4-icon"
									@click="openurl(data.facebook)">
								<!-- twitter -->
								<img src="../../assets/imgs/footer-icon-2.png" class="s4-icon"
									@click="openurl(data.twitter)">
								<!-- instagram -->
								<img src="../../assets/imgs/footer-icon-3.png" class="s4-icon"
									@click="openurl(data.instagram)">
								<!-- linkedin -->
								<img src="../../assets/imgs/footer-icon-4.png" class="s4-icon"
									@click="openurl(data.linkedin)">
							</div>
						</div>
					</div>
					<div class="col-7">
						<div class="row">
							<div class="col-6">
								<input type="text" style="width:100%;" class="s4-input" placeholder="your name"
									v-model="name">
							</div>
							<div class="col-6">
								<input type="text" style="width:100%;" class="s4-input" placeholder="your phone"
									v-model="phone">
							</div>
						</div>
						<div style="" class="mt">
							<input type="text" style="width:100%;" class="s4-input" placeholder="your email"
								v-model="email">
						</div>
						<textarea cols="30" rows="10" style="width: 100%;height: 12rem;margin-top: 1.5rem;"
							class="s4-input" placeholder="your content" v-model="content"></textarea>
						<div style="margin-top: 1rem;width: 100%;display: flex;align-items: center;justify-content: center;color: #000;font-weight: bold;font-size: 1.2rem;
									height: 3.5rem;cursor: pointer;border-radius: 0.3rem;" class="btn-cyan-liner" @click="msgsubmit()">
							Submit
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- footer -->
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '/src/components/header.vue'
import Footer from '/src/components/footer.vue'
// import GciGoogleTranslate from '/src/components/gci-google-translate.vue'
import Question from '/src/components/question.vue'
export default {
	data() {
		return {
			piclist: [
				{
					img: require('../../assets/imgs/topic.jpg'),
					name: 'Vanessa Naketa'
				},
				{
					img: require('../../assets/imgs/topic.jpg'),
					name: 'Vanessa Naketa'
				},
				{
					img: require('../../assets/imgs/topic.jpg'),
					name: 'Vanessa Naketa'
				},
				{
					img: require('../../assets/imgs/topic.jpg'),
					name: 'Vanessa Naketa'
				},
				{
					img: require('../../assets/imgs/topic.jpg'),
					name: 'Vanessa Naketa'
				},
				{
					img: require('../../assets/imgs/topic.jpg'),
					name: 'Vanessa Naketa'
				},
				{
					img: require('../../assets/imgs/topic.jpg'),
					name: 'Vanessa Naketa'
				},
				{
					img: require('../../assets/imgs/topic.jpg'),
					name: 'Vanessa Naketa'
				},
			],
			name: '',
			phone: '',
			email: '',
			content: '',
			islogin: false,
			headers: {},
			data: {},

			topimglist: [],
			active: 0,
			t: null
		}
	},
	components: {
		Header,
		Footer,
		Question
		// GciGoogleTranslate
	},
	filters: {
	},
	methods: {
		msgsubmit() {
			if (this.name == '' || this.phone == '' || this.email == '' || this.content == '') {
				// alert('not empty')
				this.$bus.$emit('message', {
					type: 1,
					msg: 'not empty'
				})
			} else {
				let params = {
					name: this.name,
					phone: this.phone,
					email: this.email,
					content: this.content
				}
				this.request({
					method: 'post',
					url: '/gci/message/add',
					data: params,
				}).then(res => {
					if (res.status == 0) {
						this.name = ''
						this.phone = ''
						this.email = ''
						this.content = ''
						this.$bus.$emit('message', {
							type: 2,
							msg: res.msg
						})
					} else {

						this.$bus.$emit('message', {
							type: 3,
							msg: res.msg
						})
					}
				}).catch(error => {
					console.error(error.response)
				})
			}
		},
		// cleanTrans() {
		//       this.delCookie('googtrans')
		//       location.reload()
		// },
		getdata() {
			this.request({
				url: '/gci/index',
				method: 'get'
			}).then(res => {
				// let { code, data, message } = res.data
				this.data = res.data.contactUs
				this.topimglist = res.data.aboutCarousels
				console.info(this.topimglist)
				// this.$bus.$emit('loading', false)
			}).catch(error => {
				console.error(error.response)
			})
		},
		openurl(url) {
			window.open(url)
		},

		clickcircle(i) {
			this.active = i - 1
			clearInterval(this.t)
		},
	},
	mounted() {
		let token = localStorage.getItem('token')
		if (token) {
			this.islogin = true
			this.headers = { authorization: token }
		}
		this.getdata()

		this.t = setInterval(() => {
			if (this.active < this.topimglist.length - 1) {
				this.active++
			} else {
				this.active = 0
			}
			console.info(this.active)
		}, 6000)
	},
	beforeDestroy() {
		clearInterval(this.t)
	}
}

</script>

<style scoped lang="scss">
.title-text {
	margin-left: -2rem;
}

.title-box {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	font-weight: 900;
	color: #000;
	font-size: 2.5rem;
}

.title-icon {
	width: 3rem;
	height: 3rem;
	margin-top: 1rem;
}

.s1-img {
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
}

.s4-title {
	font-size: 1.3rem;
	font-weight: bold;
	margin-bottom: 0.5rem;
	color: #333;
}

.s4-text {
	font-size: 1rem;
	font-weight: 400;
	margin-bottom: 0.7rem;
	color: #666
}

.s4-icon {
	width: 1.8rem;
	height: 1.8rem;
	margin-right: 0.5rem;
	cursor: pointer;
}

.s4-input {
	background-color: #f5f6f7;
	border: none;
	padding: 1rem;
	font-size: 1rem;
	color: #000;
	border-radius: 0.3rem;
	font-weight: 500;
	border: 1px solid transparent;
}

.s4-input:hover {
	border: 1px solid #000;
}

.s4-input::placeholder {
	font-weight: normal;
}

.s1-box {
	padding-top: 10rem
}

.mt {
	margin-top: 1rem;
}

.transition-normal {
	transition: all 1s cubic-bezier(.02, .01, .47, 1);
}

@media (max-width:767px) {
	.mt {
		margin-top: 0;
	}

	.s1-box {
		padding-top: 5rem
	}

	.row {
		padding: 0rem !important;
	}

	.col-6 {
		min-width: 100%;
	}

	.s1-r {
		margin-top: 5rem;
	}

	.col-3 {
		min-width: 50%;
	}

	.s2-img {
		height: 15rem !important;
	}

	.col-2 {
		min-width: 33.33%;
	}

	.col-5 {
		min-width: 100%;
	}

	.col-7 {
		min-width: 100%;
		margin-top: 2rem;

		.s4-input:nth-child(1) {
			margin-top: 1.5rem;
		}
	}

	.s1-img {
		width: 21rem !important
	}

	.s1-img-bg {
		width: 19rem !important;
	}

	.s1-row {
		padding: 1rem !important;
	}
}
</style>